import { useMutation, useQueryClient } from '@tanstack/react-query';
import { logout, UnauthenticatedError } from '@sentinel/auth-core';
import { useApi } from '../../lib/api';

export function useLogout() {
  const api = useApi();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      try {
        await logout(api);
      } catch (e) {
        if (e instanceof UnauthenticatedError) return;
        const status = (e as { status?: number } | null)?.status;
        if (status === 401) return;
        throw e;
      }
    },
    onSettled: () => {
      // Drop ALL cached queries on logout so a same-tab re-login as a different
      // user cannot resolve against the prior user's cached data (e.g.
      // ['launch-products']). Subsumes the previous session-only invalidate.
      queryClient.clear();
    },
  });
}
